import type { TeamFunctionName, UserTypesName } from "../../../../referential"

const isUserAdherent = (type?: UserTypesName | null) => {
  return type === "HOLDER" || type === "TEAM"
}

export const isBirthDateRequired = isUserAdherent

export const isExternSpecRequired = (type?: UserTypesName | null) => {
  return type === "EXTERN"
}

export const isFunctionRequired = (
  type?: UserTypesName | null,
  teamFunction?: TeamFunctionName | null,
) => {
  return type === "TEAM" && teamFunction === "OTHER"
}

export const isPhoneRequired = isUserAdherent

export const isRPPSIdRequired = (
  type?: UserTypesName | null,
  teamFunction?: TeamFunctionName | null,
) => {
  return type === "HOLDER" || teamFunction === "ASSISTANT_PHARMACIST"
}

export const RPPSIdLength = 11

export const isTeamFunctionRequired = (type?: UserTypesName | null) => {
  return type === "TEAM"
}

export const isTitleRequired = isUserAdherent
